import { AppLauncherConfig } from '../types';
import { createWechatLaunchStrategy } from '../strategy/wechat';
import { createQQLaunchStrategy } from '../strategy/qq';
import { IS_IOS } from '../util/ua';


export const PIAN_DUO_DUO_CONFIG: AppLauncherConfig = {
  intent: {
    package: 'com.tencent.submarine',
  },
  scheme: {
    protocol: 'submarine',
    host: 'com.tencent.submarine',
  },
  fallback() {
    if (IS_IOS) {
      return 'itms-apps://itunes.apple.com/app/id1560948361';
    }
    return 'DOWNLOAD:http://dldir1.qq.com/qqmi/pdd/gray_online/pianduoduo_V1.3.5.25040.apk';
  },
  customLaunch: [
    createWechatLaunchStrategy({
      packageName: 'com.tencent.submarine',
      packageUrl: 'submarine://com.tencent.submarine',
      skipCheck: true,
      downloader: {
        developer: '腾讯公司',
        icon: '',
        name: '片多多',
        getAppVersion: () => '',
        permissionUrl: '',
        privacyAgreementUrl: '',
      },
    }),
    createQQLaunchStrategy({
      packageName: 'com.tencent.submarine',
      packageUrl: 'submarine://com.tencent.submarine',
      skipCheck: true,
      downloader: {
        appid: '',
        via: 'ANDROID.SUBMARINE',
      },
    }),
  ],
};
